import { render } from "./PublicationOverviewPage.vue?vue&type=template&id=725c51b6&scoped=true"
import script from "./PublicationOverviewPage.vue?vue&type=script&lang=js"
export * from "./PublicationOverviewPage.vue?vue&type=script&lang=js"

import "./PublicationOverviewPage.vue?vue&type=style&index=0&id=725c51b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-725c51b6"]])

export default __exports__